export enum RequestCustomerAutocompleteFormat {
  regular,
  long,
}
